import {useSiteLanguage} from "../career/SiteLanguage";
import React, { useEffect, useState } from "react";
import axios from "axios";
import {Link, useNavigate} from 'react-router-dom';
import {ArrowRight, FileText, Briefcase, UserRound} from 'lucide-react';
import "../styles/Profil.css";
import EvrakPopup from "./EvrakPopup";
import CropperPopup from "../components/CropperPopup";
import {asArray,useCareerLanguage} from '../career/CareerLanguage';
import '../career/CareerAccount.css';
import {jobLabel,jobLocation} from '../utils/jobPresentation';
import {catalogLabel} from '../career/CareerCatalog';

const AdayProfil = ({view='profile'}) => {
  const navigate=useNavigate();
  const {tx,lang} = useSiteLanguage();
  const {t}=useCareerLanguage();
  const [basvurular, setBasvurular] = useState([]);
  const [ilanlar, setIlanlar] = useState([]);
  const [mulakatlar, setMulakatlar] = useState([]);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [showFullPhoto, setShowFullPhoto] = useState(false);
  const [cropImageUrl, setCropImageUrl] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [loading,setLoading]=useState(true),[applicationError,setApplicationError]=useState(false);

  const kullaniciAdi = localStorage.getItem("userName") || "Kullanıcı";
  const kullaniciMail = localStorage.getItem("userEmail") || "E-posta";
  const token = localStorage.getItem("token");

  useEffect(() => {
    if(view==='applications'){fetchIlanlar();fetchBasvurular();fetchMulakatlar();}
    if(view==='profile')fetchPhoto();
    // Each route loads only its own data; these requests use the current JWT.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view,token]);

  const fetchIlanlar = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Ilan/getirhepsi`);
      setIlanlar(asArray(res.data));
    } catch (err) {
      console.error("❌ İlanlar alınamadı:", err);
    }
  };

  const fetchBasvurular = async () => {
    setLoading(true);setApplicationError(false);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Basvuru/basvurularim`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBasvurular(asArray(res.data));
    } catch (err) {
      console.error("❌ Başvurular alınamadı:", err);
      setApplicationError(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchMulakatlar = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Mulakat/getirhekullanici`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMulakatlar(asArray(res.data));
    } catch (err) {
      console.error("❌ Mülakat verisi alınamadı:", err);
    }
  };

  const fetchPhoto = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      const imgUrl = URL.createObjectURL(res.data);
      setProfilePhoto(imgUrl);
    } catch (err) {
      console.error("❌ Profil fotoğrafı alınamadı:", err);
    }
  };

  return (
    <main className="profil-modern-container career-account">
      <nav className="career-account-nav" aria-label={tx('Profil')}>
        <Link to="/profil" aria-current={view==='profile'?'page':undefined}>{tx('Profil')}</Link>
        <Link to="/basvurularim" aria-current={view==='applications'?'page':undefined}>{tx('Başvurularım')}</Link>
        <Link to="/evraklarim" aria-current={view==='documents'?'page':undefined}>{tx('Evraklarım')}</Link>
      </nav>
      {/* Üst Bilgi */}
      {view==='profile'&&<><div className="profil-header">
        <div className="profil-avatar-wrapper">
          {profilePhoto ? (
            <>
              <img
                src={profilePhoto}
                alt={tx("Profil")}
                className="profil-avatar-img"
                onClick={() => setShowFullPhoto(true)}
                style={{ cursor: "pointer" }}
              />
              <button className="profil-edit-btn" onClick={() => document.getElementById("photoUpload").click()}>{tx("Fotoğrafı Değiştir")}</button>
            </>
          ) : (
            <>
              <div className="profil-avatar-empty"></div>
              <label htmlFor="photoUpload" className="upload-link">{tx("Profil fotoğrafı yükle")}</label>
            </>
          )}

          <input
            id="photoUpload"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files[0];
              if (!file) return;

              const reader = new FileReader();
              reader.onloadend = () => {
                setCropImageUrl(reader.result);
                setShowCropper(true);
              };
              reader.readAsDataURL(file);
            }}
          />
        </div>

        <div className="profil-info">
          <h2>{kullaniciAdi}</h2>
          <p>{kullaniciMail}</p>
        </div>
      </div><div className="career-account-shortcuts">{[
        ['/ozgecmisim','Özgeçmişim',UserRound],['/basvurularim','Başvurularım',Briefcase],['/evraklarim','Evraklarım',FileText]
      ].map(([to,label,Icon])=><Link to={to} key={to}><Icon size={24} aria-hidden="true"/><span>{tx(label)}</span><ArrowRight size={18} aria-hidden="true"/></Link>)}</div></>}

      {/* Başvurularım */}
      {view==='applications'&&<section className="kullanici-profil-section">
        <h1>{tx("Başvurularım")}</h1>
        {loading?<p role="status">{t('loading')}</p>:applicationError?<div role="alert"><p>{t('error')}</p><button type="button" onClick={fetchBasvurular}>{t('retry')}</button></div>:basvurular.length === 0 ? (
          <p className="no-basvuru-mesaji">{tx("Henüz bir başvurunuz bulunmamaktadır.")}</p>
        ) : (
          <div className="basvuru-card-wrapper">
            {basvurular.map((item, index) => {
              const ilan = ilanlar.find(i => i.ilanId === item.ilanId);
              const ilgiliMulakat = mulakatlar.find(m => m.basvuruId === item.basvuruId);
              const basvuruSurecMap = {
                1: "İnceleme Bekleniyor",
                2: "Mülakat Bekleniyor",
                3: "Evrak Bekleniyor",
                4: "Onay Bekleniyor",
              };
              const durumAdi = basvuruSurecMap[item.basvuruSurecId] || "Beklemede";

              return (
                <div className="basvuru-card" key={item.basvuruId||index}>
                  <h4>
                    {ilan?.ilanBaslik || t('jobs')}{ilan?.magazaAdi ? ` - ${ilan.magazaAdi}` : ""}
                  </h4>
                  {jobLocation(ilan,lang)&&<p>📍 {jobLocation(ilan,lang)}</p>}
                  {jobLabel(ilan?.ilanPozisyonAdi)&&<p>🧑‍💼 {catalogLabel('position',jobLabel(ilan.ilanPozisyonAdi),lang)}</p>}
                  <p>📅 {new Date(item.basvuruTarihi).toLocaleDateString(lang)}</p>
                  <p>{tx("📊 Durum:")} <strong>{catalogLabel('applicationStatus',durumAdi,lang)}</strong></p>

                  {ilgiliMulakat && (
                    <div className="mulakat-bilgisi">
                      <hr style={{ margin: "10px 0" }} />
                      <p>{tx("📅 Mülakat Tarihi :")}{" "}
                        <strong>
                          {new Date(ilgiliMulakat.mulakatTarihi).toLocaleDateString(lang)}{" "}
                          {new Date(ilgiliMulakat.mulakatTarihi).toLocaleTimeString(lang, {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </strong>
                      </p>
                      <p className="adres-tam">{tx("📍 Adres:")}<strong>{ilgiliMulakat.mulakatAdresi}</strong>
                        <br />
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ilgiliMulakat.mulakatAdresi)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginLeft: "5px", color: "#d91e18" }}
                        >
                          Google Maps
                        </a>{" "}
                        -{" "}
                        <a
                          href={`http://maps.apple.com/?q=${encodeURIComponent(ilgiliMulakat.mulakatAdresi)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginLeft: "5px", color: "#d91e18" }}
                        >
                          Apple Maps
                        </a>
                      </p>
                      <p>{tx("👤 Mülakatı Yapan :")}{" "}
                        <strong>
                          {ilgiliMulakat.mulakatYapanAd} {ilgiliMulakat.mulakatYapanSoyad}
                        </strong>
                      </p>
                      <p>{tx("📞 İletişim :")}<strong>{ilgiliMulakat.mulakatYapanTelefon}</strong>
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>}

      {showCropper && (
        <CropperPopup
          image={cropImageUrl}
          onCancel={() => setShowCropper(false)}
          onCropComplete={async (croppedBlob) => {
            setShowCropper(false);

            const formData = new FormData();
            formData.append("Foto", croppedBlob, "pp.jpg");

            try {
              await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppyukle`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${token}`,
                },
              });
              fetchPhoto();
            } catch (err) {
              console.error("❌ Fotoğraf yüklenemedi:", err);
            }
          }}
        />
      )}

      {showFullPhoto && (
        <div className="photo-modal-overlay" onClick={() => setShowFullPhoto(false)}>
          <div className="photo-modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={profilePhoto} alt={tx("Büyük Profil")} />
            <span className="photo-modal-close" onClick={() => setShowFullPhoto(false)}>✖</span>
          </div>
        </div>
      )}

      {/* Evraklarım */}
      {view==='documents'&&<section className="kullanici-profil-section"><h1>{tx("Evraklarım")}</h1><EvrakPopup inline onClose={()=>navigate('/profil')}/></section>}
    </main>
  );
};

export default AdayProfil;
